import create from 'zustand'

interface VisibleState {
  visible: boolean
  setVisible: (x: boolean) => void
}

export const useNeutralStateMenuVisible = create<VisibleState>((set) => ({
  setVisible: (visible: boolean) => set({ visible }),
  visible: false,
}))
